import { Container } from './Opportunity.styles';
import { PublicIssue } from '@hud/portal-dtos/issues-v2.dtos';
import { HudIcon } from '../../../../Icons/HudIcons';
import Entity from '../../Entity/Entity';
import Button from '../../Button/Button';
import ServiceBadge from '../../ServiceBadge/ServiceBadge';
import Pimple from '../../Pimple/Pimple';

export type FixingOpportunityProps = {
  issue: PublicIssue;
  issueServiceUrl?: string;
  issueUrl?: string;
  menuElement?: React.ReactNode;
};

export default function Opportunity({
  issue,
  issueUrl,
  issueServiceUrl,
  menuElement,
}: FixingOpportunityProps) {
  const firstSource = issue.sources[0];
  const otherSources = issue.sources.slice(1);

  const otherSourcesPopoverContent = (
    <ul>
      {otherSources.map((source) => (
        <li>
          <Entity entity={source} />
        </li>
      ))}
    </ul>
  );
  const otherSourcesPimple = otherSources.length > 0 && (
    <Pimple
      label={`+${otherSources.length}`}
      popoverContent={otherSourcesPopoverContent}
    />
  );

  return (
    <Container>
      <div className="cardHeader">
        <div className="severity">
          <HudIcon icon="designSystem.warningTriangleSolid" size={'20px'} />
        </div>
        <div className="timeStamp">{issue.detectionTime.toLocaleString()}</div>
        {menuElement}
      </div>
      <div className="cardBody">
        <p className="title">{issue.shortTitle}</p>
        <p className="entity">
          <Entity entity={issue.mainEntity} />
          <ServiceBadge name={issue.serviceName} url={issueServiceUrl ?? ''} />
        </p>
        <p className="rootCauseCaption">Root cause:</p>
        <p className="sourceEntity">
          {firstSource && <Entity entity={firstSource} />}
          {otherSourcesPimple}
        </p>
      </div>
      {issueUrl && (
        <div className="cardFooter">
          <Button href={issueUrl} size={'tiny'}>
            View & Fix Issue
          </Button>
        </div>
      )}
    </Container>
  );
}

export function EmptyStateCard() {
  return (
    <Container className="emptyStateCard">
      <div className="cardBody">
        <p>
          Once new issues are detected, you'll see them here. Explore what Hud is looking for in{' '}
          <a href="/heads-up/rules/">Detection Rules</a>.
        </p>
      </div>
    </Container>
  );
}
